var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.contentData) ? _c('div', {
    key: _vm.dataReady,
    class: ['contact-content__container', _vm.getRouteLeave ? 'contact-content__container--leave' : '']
  }, [_c('div', {
    staticClass: "contact-content__text",
    style: ({
      minHeight: !_vm.getMobile && _vm.getViewport ? ((_vm.getViewport.height - 200 - 182) + "px") : '0'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contentData.body[0].content.rendered)
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d735735a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/content-type/Contact.vue
// module id = Fx8Y
// module chunks = 1